import { render, staticRenderFns } from "./GlobalDisplay.vue?vue&type=template&id=4e36902e&"
import script from "./GlobalDisplay.vue?vue&type=script&lang=js&"
export * from "./GlobalDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDisplay.vue?vue&type=style&index=0&id=4e36902e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports